import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { Controller } from 'react-hook-form';
import UploadFile from '../../../components/UploadFile';
import SelectTag from '../../../components/SelectTag';
import { productTicketTypeOptions } from '../../../utils/OptionUtils';
import { statusOptions, priorityOptions } from '../../../utils/OptionUtils';
import ProductService from '../../../services/ProductService';
import AsyncSelect from 'react-select/async';

const CreateUpdateAnonymousTicket = ({ show, handleClose, control, register, errors, handleSubmit, customerOptions, onAnonymousTicketSubmit, setCustomerId = {}, setValue }) => {
    const [uploadedUrls, setUploadedUrls] = useState([]);
    const [requiredProduct, setRequiredProduct] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState(null);


    const fetchAllProductOptions = async () => {
        try {
            const response = await ProductService.list();
            if (response?.status === 200) {
                return response?.data?.data.map(product => ({
                    value: product.id,
                    label: product.name,
                }));
            }
        } catch (error) {
            console.error("Error fetching product options:", error);

        }
    }

    const handleFileUpload = (urls) => {
        setUploadedUrls(urls);
    }
    const handleTypeChange = (type) => {
        if (type === 'demo') {
            fetchAllProductOptions();
            setRequiredProduct(true);
        } else {
            setRequiredProduct(false);
            setSelectedProduct(null);
            setValue('product_id', null);
        }
    }
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create Anonymous Ticket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit((data) => onAnonymousTicketSubmit({ ...data, document: uploadedUrls }))}>
                    <div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Customer</label>
                            <SelectTag
                                name="customer_id"
                                control={control}
                                options={customerOptions}
                                label="customer"
                                onChange={(selectedCustomer) => {
                                    setCustomerId(selectedCustomer?.value);
                                }}
                                isRequired={true}
                            />
                            {errors?.customer_id && <small className="text-danger">{errors?.customer_id?.message}</small>}
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Type</label>
                            <SelectTag
                                name="type"
                                control={control}
                                options={productTicketTypeOptions}
                                label="demo, without product, anonymous, if necessary"
                                onChange={(selectedType) => {
                                    handleTypeChange(selectedType?.value);
                                }}
                                defaultValue={productTicketTypeOptions[0].value}
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label fw-bold">Product</label>
                        <Controller
                            name="product_id"
                            control={control}
                            rules={{ required: requiredProduct ? 'Product is required.' : false }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    cacheOptions
                                    defaultOptions
                                    isClearable={true}
                                    // isDisabled={!requiredProduct}
                                    loadOptions={requiredProduct? fetchAllProductOptions: []}
                                    onChange={(selectedOption) => {
                                        setSelectedProduct(selectedOption);
                                        field.onChange(selectedOption ? selectedOption.value : null);
                                    }}
                                    value={selectedProduct}
                                    placeholder="Select a product" />
                            )}
                        />
                        {errors?.product_id && <small className="text-danger">{errors?.product_id?.message}</small>}
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label className="fw-bold">Priority</label>
                            <SelectTag
                                name="priority"
                                control={control}
                                options={priorityOptions}
                                label="priority"
                                defaultValue={priorityOptions[0].value}
                                isRequired={true}
                            />
                            {errors?.priority && (
                                <p className="text-danger mt-2">{errors?.priority?.message}</p>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label className="fw-bold">Status</label>
                            <SelectTag
                                name="status"
                                control={control}
                                options={statusOptions}
                                label="status"
                                defaultValue={statusOptions[0].value}
                                isRequired={true}
                            />
                            {errors?.status && (
                                <p className="text-danger mt-2">{errors?.status?.message}</p>
                            )}
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label htmlFor='title' className="fw-bold">Title</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter title"
                                {...register('title', {
                                    required: 'Title is required.',
                                    maxLength: {
                                        value: 60,
                                        message: 'Title must not exceed 60 characters.',
                                    },
                                })}
                            />
                            {errors?.title && (
                                <p className="text-danger mt-2">{errors?.title?.message}</p>
                            )}
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label htmlFor='description' className="fw-bold">Description</label>
                            <textarea
                                className="form-control"
                                placeholder="Enter description"
                                {...register('description', {
                                    required: 'Description is required.',
                                    maxLength: {
                                        value: 255,
                                        message: 'Description must not exceed 255 characters.',
                                    },
                                })}
                            />
                            {errors?.description && (
                                <p className="text-danger mt-2">{errors?.description?.message}</p>
                            )}
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="fw-bold">Document</label>
                            <UploadFile folderName="support-ticket" onFileUpload={handleFileUpload} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <Button variant="danger" size='sm' onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="primary" size='sm'>
                            Create
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateUpdateAnonymousTicket